import React from 'react'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
import { Input, InputNumber, Switch } from 'antd'

const CoopCard97Extension = props => {
  const { data, handleExtSave } = props

  const { number1, number2, string5, string6 } = data

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '120px 150px 120px 350px',
        gridGap: '10px',
        padding: '10px',
      }}
    >
      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
        Event Group :
      </div>
      <InputNumber
        value={number1}
        onChange={value => handleExtSave('number1', value)}
        key="number1"
        style={{ width: '100%' }}
      />

      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>SMEPA Id :</div>
      <Input
        value={string5}
        onChange={e => handleExtSave('string5', e.target.value)}
        key="string5"
        style={{ width: '100%' }}
      />

      {/* Switch */}
      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
        Include MMC :
      </div>
      <div style={{ alignSelf: 'center' }}>
        <Switch
          checked={string6 === 'Y'}
          onChange={checked => handleExtSave('string6', checked ? 'Y' : 'N')}
          checkedChildren="Include"
          unCheckedChildren="Exclude"
          key="switch-string6"
        />
      </div>

      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>MMC :</div>
      <InputNumber
        value={number2}
        onChange={value => handleExtSave('number2', value)}
        key="number2"
        style={{ width: '40%' }}
      />
    </div>
  )
}

export default connect(state => ({ targetInfo: getApiTargetInfo(state) }))(
  CoopCard97Extension
)
